module.exports = __webpack_public_path__ + "static/MinistrstvoGospodarstvo-b5df3dfccb7ac916f935c1f8df10c6c5.png";